import styled from "styled-components";
import TextareaAutosize from "react-textarea-autosize";

export const Textarea = styled(TextareaAutosize)`
  display: block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`;
